module.exports = __webpack_public_path__ + "assets/img/lqt.3d05aa8a.png";